import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface LanguageState {
  language: 'en' | 'fr';
  setLanguage: (language: 'en' | 'fr') => void;
}

export const useLanguageStore = create<LanguageState>()(
  persist(
    (set) => ({
      language: 'fr', // Changed from 'en' to 'fr'
      setLanguage: (language) => set({ language }),
    }),
    {
      name: 'language-storage',
    }
  )
);